import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { AppConfig } from "../../../AppConfig";
import { PageRoutes } from "../../../constants/routes";
import { LocalStorageManager } from "../../../core/storage/LocalStorageManager";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";

export const useLogin = () => {
  const dispatch = useDispatch();
  const { navigateToPage } = useNavigation();
  const { state } = useLocation();
  const { redirectPath } = state ?? {};

  const handleLogin = useCallback((email: string, password: string) => {
    dispatch(appActions.showLoading());
    dispatch(
      authActions.login.started({
        login_id: email,
        password,
        onComplete: () => dispatch(appActions.hideLoading()),
        onSuccess: () => {
          const appToken: string | null =
            LocalStorageManager.Instance.getObject(
              AppConfig.Instance.LocalStorageKey["appToken"],
            );

          if (appToken) {
            dispatch(
              authActions.saveExternalId.started({
                app_token: appToken,
              }),
            );
          }

          if (redirectPath) navigateToPage(redirectPath, true);
          else navigateToPage(PageRoutes.HOME, true);
        },
      }),
    );
  }, []);

  return { handleLogin };
};
